const PATCH_FLAG = '__retailgoDomExternalMutationGuard';
let guardDepth = 0;

/**
 * Chrome's translator (and some extensions) wrap text in extra nodes such as
 * `<font>`. React then calls insertBefore/removeChild on a reference that is
 * no longer a child of the expected parent, and the sale flow error boundary
 * replaces the step. Skip those mismatched operations so the commit can finish.
 */
export function installDomExternalMutationGuard(
  nodePrototype = typeof Node === 'function' ? Node.prototype : null
) {
  if (!nodePrototype || nodePrototype[PATCH_FLAG]) {
    return false;
  }

  const originalRemoveChild = nodePrototype.removeChild;
  const originalInsertBefore = nodePrototype.insertBefore;

  nodePrototype.removeChild = function removeChild(child) {
    if (guardDepth > 0) {
      return originalRemoveChild.call(this, child);
    }

    guardDepth += 1;
    try {
      if (!child || child.parentNode !== this) {
        return child;
      }
      return originalRemoveChild.call(this, child);
    } finally {
      guardDepth -= 1;
    }
  };

  nodePrototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (guardDepth > 0) {
      return originalInsertBefore.call(this, newNode, referenceNode);
    }

    guardDepth += 1;
    try {
      if (referenceNode && referenceNode.parentNode !== this) {
        return newNode;
      }
      return originalInsertBefore.call(this, newNode, referenceNode);
    } finally {
      guardDepth -= 1;
    }
  };

  Object.defineProperty(nodePrototype, PATCH_FLAG, {
    value: true,
    enumerable: false
  });

  return true;
}
